/**
 * WhatsApp click-to-chat helpers.
 * Numbers must be in international E.164 format: "+" then 8 to 15 digits,
 * no leading zero after the "+". Spaces, dashes and brackets are ignored.
 */
const E164 = /^\+[1-9]\d{7,14}$/;

export function normaliseWhatsAppNumber(value) {
  if (typeof value !== "string") return null;
  const compact = value.trim().replace(/[\s\-().]/g, "");
  return E164.test(compact) ? compact : null;
}

/** https://wa.me/<digits>?text=... or null when the number is not valid. */
export function buildWhatsAppLink(number, message) {
  const valid = normaliseWhatsAppNumber(number);
  if (!valid) return null;
  const digits = valid.slice(1);
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
}
